<template>
  <section class="about-page">
    <div class="page-container">
      <a class="title-container" id="about">
        <img class="title-icon" src="@/assets/navbar/about_icon.png" alt="Icon">
        <h1 class="title">{{ $t('about.about') }}</h1>
      </a>
    </div>

    <div class="info">
      <div class="image-container">
        <img class="jesus-pic" src="@/assets/about/jesus_pic.png" alt="Icon">
      </div>
      <div class="name-info">
        <h2 class="name">Jérffeson Jésus</h2>
        <h3 class="role">{{ $t('about.role') }}</h3>
      </div>
    </div>

    <SocialIcons/>

    <section id="about" class="text">
      <span>
        <p>{{ $t('about.about-text-1') }}</p>
        <p>{{ $t('about.about-text-2') }}</p>
        <p>{{ $t('about.about-text-3') }}</p>
        <p>{{ $t('about.about-text-4') }}</p>
      </span>
    </section>

    <div class="download">
      <button @click="downloadCV" class="download-button">
        <img src="@/assets/about/download.png" alt="Download" class="download-icon">
        <span class="download-text">{{ $t('about.download-cv') }}</span>
      </button>
    </div>
  </section>
</template>

<script>
import SocialIcons from "@/components/Helpers/SocialIcons.vue";
import pdfFile from "@/assets/files/Jerffeson-Resume.pdf"; // Importa o PDF diretamente

export default {
  components: {
    SocialIcons
  },
  methods: {
    downloadCV() {
      const link = document.createElement("a");
      link.href = pdfFile;
      link.download = "Jerffeson Jesus Resume.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
  .download{
    display: flex;
    justify-content: center;
  }
  .download-button {
    display: inline-flex;
    padding: 10px 20px;
    background-color: #4787FC; /* Cor de fundo do botão */
    color: white; /* Cor do texto do botão */
    text-decoration: none;
    border-radius: 20px;
    transition: ease 0.3s;
    border-color: #4787FC;
  }
  
  /* Estilo para o botão quando o mouse passa por cima */
  .download-button:hover {
    background-color: #2e76fc; /* Cor de fundo alterada ao passar o mouse */
    transform: scale(1.05); 
    transition: ease 0.3s;
  }
  
  /* Estilo para a imagem dentro do botão */
  .download-icon {
    margin-right: 5px; /* Espaçamento à direita da imagem */
  }
  
  .download-text{
    font-family: 'Poppins-Bold';
    color: white;
    font-size: 30px;
    text-align: justify;
    margin-top: 5px;
}
  
  .info{
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }
  .name-info{
    display: grid;
    margin-left: 20px;
  }
  .about-page{
    margin-top: 45px;
    background-color:#212121;
    margin-left: -8px;
    margin-right: -8px;
    margin-bottom: -10px;
  }
  
  .page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -50px;
    background-color: #111111;
  }
  
  .title-container {
    display: flex;
    align-items: center; /* Centraliza verticalmente */
  }
  
  
  .title {
    font-family: 'Poppins-Regular';
    color: white;
    text-transform: uppercase;
    font-size: 32px;
    margin-left: 10px; /* Ajuste conforme necessário */
  }
  
  .name {
    font-family: 'Poppins-Regular';
    color: white;
    font-size: 68px;
    margin-left: 10px; /* Ajuste conforme necessário */
    margin-top: -15px;
  }
  .role {
    font-family: 'Poppins-Thin';
    color: white;
    font-size: 30px;
    margin-left: 10px; /* Ajuste conforme necessário */
    margin-top: -15px;
  }
  .text{
    font-family: 'Poppins-Regular';
    color: white;
    font-size: 20px;
    text-align: justify;
    margin-left: 14.5%;
    margin-right: 14.5%;
    word-spacing: 0.1em;
  }
  @media(max-width: 1200px){
    .text{
      margin-left: 8%;
      margin-right: 8%;
    }
    .image-container{
      justify-content: center;
      display: flex;
    }
    .info{
      display: block;
    }
    .name,
    .role{
      text-align: center;
      margin-left: 0px;
    }
    .name-info{
      margin-left: 0px;
    }
    .name{
      font-size: 50px;
    }
    .role{
      font-size: 24px;
    }
  }
  
 
  </style>
  